import { montarPaginacao, paginacaoDa, type PaginacaoNaUrl } from '@/lib/paginacao-na-url';

/* Reexportados para a pagina ter UM import do assunto. */
export { OPCOES_POR_PAGINA, PADRAO_POR_PAGINA } from '@/lib/paginacao-na-url';

/**
 * O estado do filtro das ordens de serviço vive na URL (p.16).
 *
 * "Olha as O.S. que fecharam no mês" é uma conversa que acontece por link. Com
 * o filtro em `useState`, o link abria sempre em "Abertas", que é o padrão — e
 * quem recebia achava que estava vendo o que foi mandado.
 */
export const FILTROS_DA_ORDEM = ['abertas', 'fechadas', 'sem_causa', 'todas'] as const;

export type Filtro = (typeof FILTROS_DA_ORDEM)[number];

/**
 * "Abertas" é o padrão, e por isso NÃO vai para a URL.
 *
 * A oficina abre no que tem trabalho pendente: é a pergunta da manhã. Pôr o
 * padrão no endereço deixaria o link de "a tela de sempre" indistinguível do
 * link de uma visão escolhida.
 */
export const FILTRO_PADRAO: Filtro = 'abertas';

export function ehFiltroDaOrdem(valor: unknown): valor is Filtro {
  return typeof valor === 'string' && (FILTROS_DA_ORDEM as readonly string[]).includes(valor);
}

export interface BuscaDasOrdens extends PaginacaoNaUrl {
  readonly filtro?: Filtro;
}

/** Valor fora do vocabulário é DESCARTADO, e a tela abre no padrão. */
export function validarBuscaDasOrdens(entrada: Record<string, unknown>): BuscaDasOrdens {
  const filtro = entrada['filtro'];
  return {
    ...(ehFiltroDaOrdem(filtro) && filtro !== FILTRO_PADRAO ? { filtro } : {}),
    ...paginacaoDa(entrada),
  };
}

/** Monta a busca para navegar, deixando de fora tudo que já é o padrão. */
export function montarBuscaDasOrdens(estado: {
  readonly filtro: Filtro;
  readonly pagina: number;
  readonly porPagina: number;
}): BuscaDasOrdens {
  return {
    ...(estado.filtro === FILTRO_PADRAO ? {} : { filtro: estado.filtro }),
    ...montarPaginacao(estado),
  };
}
